import { Flex, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Overline2 } from "src/atoms/typography";
import premiumIcon from "./premium.svg";

export default function PremiumBadge({
  top = "20px",
  left = "24px",
  absolute = true
}) {
  const { t } = useTranslation();
  return (
    <Flex
      alignItems="center"
      {...(absolute && {
        position: "absolute",
        top,
        left
      })}
    >
      <Image width="16px" mr="6px" src={premiumIcon} />
      <Overline2 fontSize="12px" lineHeight="12px" color="white">
        {t("premiumTitle").toUpperCase()}
      </Overline2>
    </Flex>
  );
}
